import {
  EditBlockColorPicker,
  EditBlockSelect,
  EditBlockTextInput,
  EditBlockNumericInput,
  EditBlockSliderInput,
  EditBlockSwitch,
} from '@components/EditBuildingBlocks/all'
import genericContentItemEditor from '@components/mixins/genericContentItemEditor'
// import { fortuneWheelPrizeDefaultTemplate } from '@components/Widgets/_contentItems/FortuneWheel/template'
// import uidGenerator from "@utils/UIDGenerator";

export default {
  name: 'FortuneWheelEditorComponent',
  mixins: [genericContentItemEditor],
  components: {
    'edit-block-color-picker': EditBlockColorPicker,
    'edit-block-select': EditBlockSelect,
    'edit-block-text-input': EditBlockTextInput,
    'edit-block-numeric-input': EditBlockNumericInput,
    'edit-block-slider-input': EditBlockSliderInput,
    'edit-block-switch': EditBlockSwitch,
  },
  data() {
    return {
      prizes: JSON.parse(JSON.stringify(this.component.content.prizes)),
      // prizeDefaultTemplate: fortuneWheelPrizeDefaultTemplate
    }
  },
  computed: {
    wheelFontFamiy: {
      get() {
        return this.component.styling.fontFamily
      },
      set(value) {
        this.updateGlobalContentItem({
          id: this.component.id,
          itemName: ['wheel'],
          path: ['styling'],
          attribute: ['fontFamily'],
          data: value,
        })
      },
    },
    wheelFontWeight: {
      get() {
        return this.component.styling.fontWeight === 'bold'
      },
      set(value) {
        const fontWeight = value ? 'bold' : 'normal'

        this.updateGlobalContentItem({
          id: this.component.id,
          itemName: ['wheel'],
          path: ['styling'],
          attribute: ['fontWeight'],
          data: fontWeight,
        })
      },
    },
    wheelTextColor: {
      get() {
        return this.component.styling.color
      },
      set(value) {
        this.updateGlobalContentItem({
          id: this.component.id,
          itemName: ['wheel'],
          path: ['styling'],
          attribute: ['color'],
          data: value,
        })
      },
    },
    wheelColor: {
      get() {
        return this.component.styling.backgroundColor
      },
      set(value) {
        this.updateGlobalContentItem({
          id: this.component.id,
          itemName: ['wheel'],
          path: ['styling'],
          attribute: ['backgroundColor'],
          data: value,
        })
      },
    },
    wheelSecondaryColor: {
      get() {
        return this.component.styling.secondaryBackgroundColor
      },
      set(value) {
        this.updateGlobalContentItem({
          id: this.component.id,
          itemName: ['wheel'],
          path: ['styling'],
          attribute: ['secondaryBackgroundColor'],
          data: value,
        })
      },
    },
  },
  watch: {
    prizes: {
      handler: function(value) {
        this.updateGlobalContentItem({
          id: this.component.id,
          itemName: ['wheel'],
          path: ['content'],
          attribute: ['prizes'],
          data: JSON.parse(JSON.stringify(value)),
        })
      },
      deep: true,
    },
  },
  // Functionality for adding/removing slices goes here
  // methods: {
  //   addSlice() {
  //     const newSlice = JSON.parse(JSON.stringify(this.prizeDefaultTemplate))
  //     const newID = uidGenerator()
  //
  //     newSlice.id = newID
  //     this.prizes.push(newSlice)
  //   },
  //   removeSlice(index) {
  //     this.prizes.splice(index, 1)
  //   },
  // },
}
